<template>
    <div class="website_wizard_menu">
        <router-link :to="{ name: 'Amenities'}">Amenities</router-link>
        <router-link :to="{ name: 'Visitor Process'}">Visitor Process</router-link>
        <router-link :to="{ name: 'Tenants'}">Tenants</router-link>
        <router-link :to="{ name: 'Pois & Links'}">Pois</router-link>
        <router-link :to="{ name: 'Street View'}">Street View</router-link>
        <router-link :to="{ name: 'Edit Website'}">Website</router-link>
    </div>
</template>
<script>
    export default {

    };
</script>
